import React from 'react';
import { BackArrowButton, CloseButton } from '../../../../../components/common';

import './list-modal-layout.scss';

interface ListModalLayoutProps {
    ariaLabelledById?: string; // This ID needs to match the id on the children's headline. ie. aria-${formName}-headline
    hasExitButton?: boolean;
    headline?: string;
    header?: JSX.Element;
    onClose?: () => void;
    onBackArrowClick?: () => void;
}

export const ListModalLayout: React.FC<ListModalLayoutProps> = ({
    ariaLabelledById,
    hasExitButton = false,
    headline,
    header,
    onClose,
    onBackArrowClick,
    children,
}): React.ReactElement => {
    const shouldShowControls = hasExitButton;

    return (
        <div className="list-modal-layout">
            <>
                {shouldShowControls && (
                    <div className="list-modal-layout__controls">
                        {onBackArrowClick && <BackArrowButton onClick={onBackArrowClick} />}
                        {hasExitButton && <CloseButton onClick={() => onClose()} />}
                    </div>
                )}

                {header && <div className="list-modal-layout__header">{header}</div>}

                {headline && (
                    <header className="list-modal-layout__header">
                        <h1 id={ariaLabelledById}>{headline}</h1>
                    </header>
                )}

                {children && (
                    <div className="list-modal-layout__content">
                        <div>{children}</div>
                    </div>
                )}
            </>
        </div>
    );
};
